function createSearchState(input, schema) {
  const filters = [];

  schema.forEach(field => {
    if (field.children && Array.isArray(field.children)) {
      // Recursively process children and merge their filters
      const childState = createSearchState(input, field.children);
      filters.push(...childState.filters);
    } else {
      const val = input[field.name];
      // skip if undefined, null, or empty string
      if (val !== undefined && val !== null && val !== '') {
        filters.push({
          field: field.name,
          operator: field.operator,
          value: val,
          searchAs: field?.searchAs,
        });
      }
    }
  });

  return { filters, paginationState: { pageIndex: 0, pageSize: 10 } };
}

export default createSearchState;
